import React from 'react';
import './Title.less';
import priorityLogo from '../../img/priority_logo.svg';

export default function Title() {
  return (
    <section className="main-title">
      <div style={{ display: 'flex', columnGap: '16px' }}>
        <a href="https://priority2030.ru/" className="priority-logo-link" target="_blank" rel="noreferrer">
          <img className="priority-logo-img" src={priorityLogo} alt="priority 2030 logo" />
        </a>
        <div>
          <h3>Программа развития УрФУ на 2025-2036 годы</h3>
        </div>
      </div>
      <a target="_blank" href="https://pro.urfu.ru/PWA/competitiveness_programme/SitePages/%D0%94%D0%BE%D0%BC%D0%B0%D1%88%D0%BD%D1%8F%D1%8F.aspx" className="other-programs" rel="noreferrer">Другие программы</a>
    </section>
  );
}
